<div class="chart-wrapper">
  <canvas baseChart 
    [data]="barChartData" 
    [options]="barChartOptions"
    [plugins]="barChartPlugins" 
    [type]="barChartType"
    (chartHover)="chartHovered($event)" 
    (chartClick)="chartClicked($event)"
    style="display: block; width: 100%; height: 100%;">
  </canvas>
</div>
